export const isNotNull = (item) =>
  item !== null && item !== undefined
